import { Component } from '@opten/compiler/metadata/component';
import { addClass } from '@opten/dom/add-class';
import { hasClass } from '@opten/dom/has-class';
import { removeClass } from '@opten/dom/remove-class';
import { toggleClass } from '@opten/dom/toggle-class';
import { PageRenderHelper } from './page-render-helper';

@Component({ className: 'js-modal' })
export class ModalComponent {
	private items: HTMLElement[];
	private headerBreadcrumb: HTMLElement;

	private static innerContent: HTMLElement;
	private static pageRenderHelper: PageRenderHelper;

	private handlers = [];

	constructor(private element: HTMLElement) {
		this.headerBreadcrumb = document.querySelector(
			'.js-header-breadcrumb'
		) as HTMLElement;
		ModalComponent.innerContent = this.element.querySelector(
			'.js-modal-inner'
		) as HTMLElement;
		ModalComponent.pageRenderHelper = new PageRenderHelper(
			ModalComponent.innerContent,
			'.js-modal-inner'
		);
		PageRenderHelper.onPageChange.subscribe(() => this.init());
		this.init();
	}

	static close() {
		if (hasClass(document.body, 'modal-is-open')) {
			removeClass(document.body, 'modal-is-open');
			this.pageRenderHelper.close(
				this.innerContent.getAttribute('data-url-parent')
			);
			return true;
		}
		return false;
	}

	private init() {
		this.items = Array.from(
			document.querySelectorAll('.js-modal-activator')
		) as HTMLElement[];

		this.handlers.forEach(handler => {
			handler.item.removeEventListener('click', handler.func);
		});
		this.handlers = [];

		this.items.forEach(item => {
			const wrappedFunc = this.activatorClickListener.bind(this, item);
			this.handlers.push({ item, func: wrappedFunc });
			item.addEventListener('click', wrappedFunc);
		});
	}

	private activatorClickListener(item: HTMLElement, e: MouseEvent) {
		e.preventDefault();
		addClass(document.body, 'rerun-visual-grid');
		setTimeout(() => {
			const url = item.getAttribute('data-url');
			addClass(document.body, 'modal-is-open');
			ModalComponent.innerContent.removeAttribute('data-url-parent');
			ModalComponent.pageRenderHelper
				.fetch(url)
				.then(({ dom, innerContent }) => {
					const header = dom.querySelector('.js-header-breadcrumb');
					toggleClass(
						document.body,
						'header-has-breadcrumb',
						header && header.innerHTML.length > 10
					);
					if (header) {
						this.headerBreadcrumb.innerHTML = header.innerHTML;
						PageRenderHelper.onPageChange.dispatch(
							this.headerBreadcrumb
						);
					} else {
						this.headerBreadcrumb.innerHTML = '';
					}
				})
				.catch(error => {})
				.finally(() => {
					removeClass(document.body, 'rerun-visual-grid');
				});
		}, 1350);
	}
}
